import '../../../styles/containers/Prayer/prayer.scss';
import '../../../styles/containers/Prayer/components/welcome.scss';
import AnimatedLoader from '../../../components/AnimatedLoader';
import SunriseGif from '../../../assets/sunrise-welcome.gif';
import React, {useEffect, useState} from 'react'
import {Routes} from '../../../constants/RouterConstants';
import { Navigation } from '../../../services/NavigationService';
import useMoengage from '../../../hooks/useMoengage';
import axios from 'axios';
// import Sound from 'react-sound';
import WelcomePrayerMusic from '../../../assets/welcome-prayer-music.mp3';

function Welcome() {

  const [isLoading, setIsLoading] = useState(true);
  const [createMoengageUser, trackEvent] = useMoengage();

  useEffect(() => {
      const paramString = window.location.href.split('?')[1];
      const queryString = new URLSearchParams(paramString);
      let userIdParam;
      queryString.forEach((value, key) => {
        if (key === 'userId') userIdParam = value;
      });
      if (!userIdParam) return;
      else {

        async function fetchUserInfoForPrayer(endPoint, query) {
          var config = {
              method: 'get',
              url: `${process.env.REACT_APP_API_HOST}/v2/app/${endPoint}?${query}`,
              headers: { 
                'Content-Type': 'application/json',
                'Access-Control-Allow-Credentials':'true',
                'Access-Control-Allow-Methods':'GET,HEAD,OPTIONS,POST,PUT',
                'Access-Control-Allow-Headers':'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
                "Cache-Control": null,
                "X-Requested-With": null  
              },
          };
            
          return axios(config).then((response) => {
              if(response.status === 200) {
                  return response.data;
              } else {
                throw new Error('Server Error');
              }
          })
        }

        fetchUserInfoForPrayer('user_details', `userId=${userIdParam}`)
        .then((userData) => {
          createMoengageUser(userIdParam, userData.name, userData.phoneNumber);
          trackEvent('worship_selection_viewed', {});
          setIsLoading(false);
          return userData.phoneNumber;
        })
        .then((phoneNumber) => fetchUserInfoForPrayer('user_faith', `phoneNumber=${phoneNumber}`))
        .then((userData) => {
            if(userData.faith && userData.metaData && userData.metaData.godKey) {
              setTimeout(() => Navigation.push({pathname: Routes.PRAYER_OFFERING, search:`userId=${userIdParam}&faith=${userData.faith}&god=${userData.metaData.godKey}`}), 5000);
            } else {
              setTimeout(() => Navigation.push({pathname: Routes.SELECT_FAITH, search:`userId=${userIdParam}`}), 5000);
            }
        }).catch((e) => {
          console.log(e.toString());
          setIsLoading(false);
          setTimeout(() => Navigation.push({pathname: Routes.SELECT_FAITH, search:`userId=${userIdParam}`}), 5000);
        })
        
      };
  })
    // const handleClick = () => {
        // if(!userPhoneNumber) {
        //   console.log('Empty Number')
        //   return;
        // }
        // console.log(userPhoneNumber);
        // var config = {
        //     method: 'get',
        //     url: `${process.env.REACT_APP_API_HOST}/v3/app/user_faith?phoneNumber=${userPhoneNumber}`,
        //     headers: { 
        //       'Authorization': `Bearer ${userAuthToken}`,
        //       'Content-Type': 'application/json',
        //       'Access-Control-Allow-Credentials':'true',
        //       'Access-Control-Allow-Methods':'GET,HEAD,OPTIONS,POST,PUT',
        //       'Access-Control-Allow-Headers':'Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers',
        //       "Cache-Control": null,
        //       "X-Requested-With": null  
        //     },
        // };
          
        // axios(config)
        //   .then(function (response) {
        //       if(response.status === 200 && response.data.faith) {
        //         const faith = response.data.faith;
        //         const god = response.data.metaData.godKey;
        //         console.log(faith, god);
        //         Navigation.push({pathname: Routes.PRAYER_OFFERING, search:`userId=${userId}&faith=${faith}&god=${god}`});
        //       } else {
        //         console.log('interesting');
        //         Navigation.push({pathname: Routes.SELECT_FAITH, search:`userId=${userId}`});
        //       }
        //   })
        //   .catch(function (error) { 
        //     console.log('Error aa gya',error);
        //   })
          // Navigation.push({pathname: Routes.SELECT_FAITH, search:`userId=${userId}`});
    // }
    
    return isLoading ? (
      <AnimatedLoader containerStyle={{height: '100vh'}}/>
    ) : (
      <div className='__main-container'>
        <audio autoPlay="autoplay" loop>
        <source src={WelcomePrayerMusic} type='audio/mp3'/>     
        </audio>
        {/* <Sound url={WelcomePrayerMusic} playStatus={Sound.status.PLAYING} loop={true} autoLoad={true}/> */}
        {/* <embed src={WelcomePrayerMusic} loop="true" autostart="true" width="0" height="0"></embed> */}
        <img className='welcome-container' src={SunriseGif} alt='loading...'></img>
      </div>
    )
}

export default Welcome;